import { __assign } from "tslib";
import { createAction } from 'redux-actions';
import { actionPrefix } from './constants';
import initActions from './initActions';
import { ModalType } from './types';
import { pushModal } from './basicActions';
import { verifyLoggedOutAccess } from '../../redux/loggedout/actionCreators';
import { ReferralType } from '@wix/da-bi/pkg/constants';
export { pushModal, popModal, replaceModal, removeModal, removeModalsOfType, } from './basicActions';
export var initModal = function (type, options) {
    // return init modal action if available
    var initModalAction = initActions[type];
    return initModalAction && initModalAction(options.params);
};
export var pushBadgeModal = verifyLoggedOutAccess(ReferralType.GIVE, function (username, onBadgeSent, onClose) {
    return pushModal(ModalType.GIVE_BADGE, {
        params: {
            username: username,
            onBadgeSent: onBadgeSent,
            onClose: onClose,
        },
    });
});
export var pushPointsModal = verifyLoggedOutAccess(ReferralType.GIVE, function (username, title) {
    return pushModal(ModalType.GIVE_POINTS, { params: { username: username, title: title } });
});
export var pushCommentsModal = function (typeId, itemId, commentId, parentComment) {
    return pushModal(ModalType.COMMENT_THREAD, {
        params: { commentId: commentId, typeId: typeId, itemId: itemId, parentComment: parentComment },
    });
};
export var pushConfirmationModal = function (params) {
    return pushModal(ModalType.CONFIRMATION, {
        params: params,
    });
};
export var pushGlobalConfirmationModal = function (params) {
    return pushModal(ModalType.GLOBAL_CONFIRMATION, {
        params: params,
        wrapInModal: false,
    });
};
export var pushGlobalConfirmationModalForMM = function (params) {
    return pushModal(ModalType.GLOBAL_CONFIRMATION_FOR_MM, {
        params: params,
        wrapInModal: false,
    });
};
export var confirmYes = createAction("".concat(actionPrefix, ".CONFIRM_YES"), function () { return ({}); });
export var confirmNo = createAction("".concat(actionPrefix, ".CONFIRM_NO"), function () { return ({}); });
export var doNotShowAgainChanged = createAction("".concat(actionPrefix, ".DO_NOT_SHOW_CHANGED"), function (key, value) { return ({ key: key, value: value }); });
export var showMobileDeviationSharePopup = function (deviation) {
    return pushModal(ModalType.MOBILE_DEVIATION_SHARE, { params: { deviation: deviation } });
};
export var showMobileSharePopup = function (url, title) {
    return pushModal(ModalType.MOBILE_SHARE, { params: { url: url, title: title } });
};
export var showCookieSettingsPopup = function () {
    return pushModal(ModalType.COOKIE_SETTINGS, {});
};
export var showDealerPopup = function (content) {
    return pushModal(ModalType.DEALER, { params: { content: content } });
};
export var showSubmitModal = verifyLoggedOutAccess(ReferralType.SUBMIT, function (type, options) {
    return pushModal(type, __assign({ wrapInModal: false }, (options || {})));
});
export var showFavouritedByModal = function (deviation) {
    return pushModal(ModalType.FAVOURITED_BY, {
        wrapInModal: false,
        params: {
            deviationId: deviation.deviationId,
            typeId: deviation.typeId,
        },
    });
};
export var showDeviantsListModal = function (selectedUserId, onItemClick) {
    return pushModal(ModalType.DEVIANTS_LIST, {
        wrapInModal: false,
        params: {
            selectedUserId: selectedUserId,
            onItemClick: onItemClick,
        },
    });
};
export var pushDasModal = verifyLoggedOutAccess(ReferralType.SUBMIT, function (type, deviation) {
    return pushModal(ModalType.DAS_MODAL, {
        params: {
            type: type,
            deviation: deviation,
        },
    });
});
export var pushNftLinkPopup = function (deviation) {
    return pushModal(ModalType.NFT_LINK, {
        params: {
            deviation: deviation,
        },
    });
};
export var pushNftEditPopup = function (deviation, nft) {
    return pushModal(ModalType.NFT_LINK, {
        params: {
            deviation: deviation,
            nft: nft,
        },
    });
};
export var showDiscordConnectSuccessModal = function (guildId) {
    return pushModal(ModalType.DISCORD_CONNECT_SUCCESS, { params: { guildId: guildId } });
};
export var showDiscordDisconnectModal = function () {
    return pushModal(ModalType.DISCORD_DISCONNECT, {});
};
export var showBadgeInfoModal = function (username, badgeId) {
    return pushModal(ModalType.BADGE_INFO, { params: { username: username, badgeId: badgeId } });
};
//# sourceMappingURL=actionCreators.js.map